module.exports = __webpack_public_path__ + "static/media/arrow-left.b701e66a.svg";